// import { exact } from "prop-types";
import React from "react";

// const ReportConfi = React.lazy(() => import('../../views/ReportConfigulation/IndexReportConfigulation'));
const TaiKhoanDonVi = React.lazy(() =>
  import("../../views/TaiKhoanDonVi/Index")
);
const UserInfor = React.lazy(() => import("../../views/UserInfor/IndexInfor"));
const ThongBao = React.lazy(() => import("../../views/ThongBao/ThongBao"));
const ListPheDuyet = React.lazy(() =>
  import("../../views/PheDuyet/ListPheDuyet")
);
const NhomPhuongTienDo = React.lazy(() =>
  import("../../views/DanhMuc/DMNhomPTD/NhomPhuongTienDo")
);
const ChuKyKiemDinh = React.lazy(() =>
  import("../../views/DanhMuc/DMChuKyKiemDinh/ChuKyKiemDinh")
);
const PhuongTienDo = React.lazy(() =>
  import("../../views/DanhMuc/DMPhuongTienDo/PhuongTienDo")
);
const ListPhuongTienDo = React.lazy(() =>
  import("../../views/DanhMuc/DMPhuongTienDo/PhuongTienDo")
);
const DonVi = React.lazy(() => import("../../views/DanhMuc/DonVi/Index"));
// const TongQuan = React.lazy(() => import('../../views/Map/MapLogined'));
const ThongTinCoSo = React.lazy(() =>
  import("../../views/DanhMuc/DonVi/Detail/ThongTinCoSo")
);
const BaoCao = React.lazy(() => import("../../views/BaoCao/Index_BaoCao"));
const GuiNhanVanBan = React.lazy(() =>
  import("../../views/GuiNhanVanBan/Index")
);
const SystemLog = React.lazy(() => import("../../views/System/Log/Index"));
const Dashboard = React.lazy(() => import("../../views/dashboard"));
const HoiDap = React.lazy(() => import("../../views/HoiDap/index"));
const HoiDapChiCuc = React.lazy(() =>
  import("../../views/HoiDapViewChiCuc/index")
);

const chucnang = [
  {
    path: "/tai-khoan",
    exact: true,
    name: "Quản lý tài khoản đơn vị",
    component: TaiKhoanDonVi,
  },
  {
    path: "/thong-tin-tai-khoan",
    exact: true,
    name: "Thông tin tài khoản",
    component: UserInfor,
  },
  {
    path: "/hoi-dap",
    exact: true,
    name: "Hỏi đáp",
    component: HoiDap,
  },
  {
    path: "/hoi-dap-chi-cuc",
    exact: true,
    name: "Hỏi đáp view chi cục",
    component: HoiDapChiCuc,
  },
  {
    path: "/thong-bao",
    exact: true,
    name: "Danh sách thông báo",
    authenticatedOnly: true,
    component: ThongBao,
  },
  {
    path: "/nhom-phuong-tien-do",
    exact: true,
    name: "Nhóm phương tiện đo",
    component: NhomPhuongTienDo,
  },
  {
    path: "/chu-ky-kiem-dinh",
    exact: true,
    name: "Chu kỳ kiểm định",
    component: ChuKyKiemDinh,
  },
  {
    path: "/phuong-tien-do",
    exact: true,
    name: "Phương tiện đo",
    component: PhuongTienDo,
  },
  {
    path: "/list-phuong-tien-do",
    exact: true,
    name: "Phương tiện đo",
    component: ListPhuongTienDo,
  },
  {
    path: "/phe-duyet-du-lieu",
    exact: true,
    name: "Phê duyệt dữ liệu",
    component: ListPheDuyet,
  },
  { path: "/co-so", exact: true, name: "Đơn vị", component: DonVi },
  { path: "/tong-quan", exact: true, name: "Dashboard", component: Dashboard },
  {
    path: "/thong-tin-co-so",
    exact: true,
    name: "Thông tin cơ sở",
    component: ThongTinCoSo,
  },
  { path: "/bao-cao", exact: true, name: "Báo cáo", component: BaoCao },
  {
    path: "/gui-nhan-van-ban",
    exact: true,
    name: "Thông tin cơ sở",
    component: GuiNhanVanBan,
  },
  {
    path: "/system-log",
    exact: true,
    name: "System log",
    component: SystemLog,
  },
];

export default chucnang;
